﻿import React from 'react';
import {connect} from 'react-redux';

import {DynamicFormLevel3Row} from '../Styles/dynamicFormStyles';

class DynamicFormLevel3QuestionRow extends React.PureComponent {
    render() {
        const QuestionTypeHandler = this.props.questionTypeHandler;

        return (
            <DynamicFormLevel3Row styleForConfirmView={this.props.currentStep === 1}>
                <QuestionTypeHandler
                    question={this.props.questionGroup}
                    formInput={this.props.formInput}
                />
            </DynamicFormLevel3Row>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({});
const mapStateToProps = (state) => ({
    currentStep: state.pageCurrentStep
});

export default connect(mapStateToProps, mapDispatchToProps)(DynamicFormLevel3QuestionRow);
